module.exports = vendor_4b6c824413248f209174;